import { CircleAlert } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { InvitationDialogLayout } from './InvitationDialogLayout';

type Props = {
  onClose: () => void;
};

export function InvitationInvalid({ onClose }: Props) {
  return (
    <InvitationDialogLayout
      icon={<CircleAlert />}
      title="This invitation isn't valid"
      description="It may have been rejected, withdrawn, or the link may be incorrect. Check the link in your email, or ask the sender to send a new invitation."
      footer={<Button onClick={onClose}>Got it</Button>}
    />
  );
}
